import * as React from 'react';
import { TRefWrapper } from '../../containers/Scrolling';
import { EAnchorBlock } from '../../repositories/price-estimator/entities/onboardings/TooltipSchema';

interface IMarketTrendsWrapper {
  children: React.ReactNode;
  refWrapper: TRefWrapper;
}
export function MarketTrendsWrapper({ children, refWrapper }: IMarketTrendsWrapper) {
  return refWrapper(<div id={EAnchorBlock.MarketTrends}>{children}</div>);
}
